import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const Docs: BleskIcon = forwardRef(function Docs(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.4142 8.91421L13.0858 6.58579C12.7107 6.21071 12.202 6 11.6716 6H5.5C4.11929 6 3 7.11929 3 8.5V18.5C3 19.8807 4.11929 21 5.5 21H13.5C14.8807 21 16 19.8807 16 18.5V10.3284C16 9.79799 15.7893 9.28928 15.4142 8.91421Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 11H12.5C11.6716 11 11 10.3284 11 9.5V6"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 6V5.5C8 4.11929 9.11929 3 10.5 3H18.5C19.8807 3 21 4.11929 21 5.5V15.5C21 16.8807 19.8807 18 18.5 18H16"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
